import { useEffect, useState } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import useScreenType from 'react-screentype-hook';
import {
  HomeOutlined,
  WarningOutlined,
  BarChartOutlined,
  CameraOutlined,
  UsergroupAddOutlined
} from '@ant-design/icons';

import Dashboard from '../pages/dashboard3';
import Header from "../../header/header";
import Alert from "../alert";
import CameraStatus from "../camerastatus";
import CrowdAnalytics from "../crowdAnalytics";
import PrivateRoute from '../../../layouts/PrivateRoute';
import axios from '../../../utils/axios'
import AttendanceLogs from '../pages/AttendanceLogs';
import Report from '../pages/report';
import StaffSummary from '../pages/staffSummary';

const { Content, Sider } = Layout;

const PAGE_ICONS = {
  dashboard: <HomeOutlined />,
  camera: <CameraOutlined />,
  alert: <WarningOutlined />,
  report: <BarChartOutlined />,
  analytics: <BarChartOutlined />,
  insights: <BarChartOutlined />,
  compliance: <WarningOutlined />,
  heatmap: <BarChartOutlined />,
  maintenance: <WarningOutlined />,
  vehicle: <CameraOutlined />,
  attendance: <UsergroupAddOutlined />,
  "attendance-logs": <UsergroupAddOutlined />,
  "staff-summary": <UsergroupAddOutlined />
};

const UserPage = ({ path }) => {
  const location = useLocation();
  const [selectedMenu, setSelectedMenu] = useState([]);
  const [items, setItems] = useState([]);
  const [collapsed, setCollapsed] = useState(false);

  const citriot = JSON.parse(localStorage.getItem("citriot"));
  const screenType = useScreenType();
  const navigate = useNavigate();
  const organizationId = localStorage.getItem('organizationId');
  const projectname = localStorage.getItem('selectedProject');
  const user = JSON.parse(localStorage.getItem('user'));
  const [dashConfig, setDashConfig] = useState(null)
  
  /* ---------------- MENU ITEM HELPER ---------------- */
  const getItem = (label, key, icon) => ({
    key,
    icon,
    label
  });

  /* ---------------- SIDEBAR WIDTH LOGIC ---------------- */
  const siderWidth = screenType.isMobile
    ? collapsed ? 60 : 150
    : collapsed ? 80 : 220;

  /* ---------------- INIT MENU ---------------- */
  useEffect(() => {

  if (location.pathname === "/user") {
    const defaultRoute = `${path}/dashboard`;
    navigate(defaultRoute, { replace: true });
  }

}, [location.pathname]);
   

  const fetchDashboardConfig = async () => {
    try {
      const res = await axios.post('/fetch-dashboard-settings', {
        organizationId,
        username: user?.username,
        projectname
      });

      if (res.data?.success) {
        setDashConfig(res.data.data.pages);
      }
    } catch (err) {
      console.error("Dashboard config fetch failed", err);
    }
  };

  useEffect(()=> {
    fetchDashboardConfig()
  },[projectname])

  const formatLabel = (page) =>
  page
    .replace(/-/g, " ")
    .replace(/\b\w/g, l => l.toUpperCase());

  const buildMenuFromConfig = (pagesConfig) => {

  if (!pagesConfig) return [];

  return Object.keys(pagesConfig)
    .filter(page => pagesConfig[page]?.enabled)
    .map(page =>
      getItem(
        formatLabel(page),
        `${path}/${page}`,
        PAGE_ICONS[page] || <HomeOutlined />
      )
    );

};

useEffect(() => {

  if (!dashConfig) return;

  const menuItems = buildMenuFromConfig(dashConfig);

  setItems(menuItems);

  const currentPath = location.pathname;

  const allowedKeys = menuItems.map(item => item.key);

  if (!allowedKeys.includes(currentPath)) {

    const firstPage = menuItems[0]?.key;

    if (firstPage) {
      navigate(firstPage, { replace: true });
      setSelectedMenu([firstPage]);
    }

  } else {
    setSelectedMenu([currentPath]);
  }

}, [dashConfig, location.pathname]);

  return (
    <Layout>
      <Header auth={citriot?.auth} />

      <Layout hasSider>
        {/* ---------- SIDEBAR ---------- */}
        <Sider
          collapsible
          collapsed={collapsed}
          onCollapse={setCollapsed}
          breakpoint="lg"
          width={screenType.isMobile ? 150 : 220}
          collapsedWidth={screenType.isMobile ? 60 : 80}
          theme="light"
          style={{
            position: 'fixed',
            top: 64,
            bottom: 0,
            left: 0,
            overflowY: 'auto',
            backgroundColor: '#ffffff',
            borderRight: '1px solid #f0f0f0'
          }}
        >
          <Menu
            mode="inline"
            selectedKeys={selectedMenu}
            items={items}
            onSelect={({ key }) => {
              navigate(key);
              setSelectedMenu([key]);
            }}
            style={{
              borderRight: 'none'
            }}
          />
        </Sider>

        {/* ---------- MAIN CONTENT ---------- */}
        <Content
          style={{
            marginLeft: siderWidth,
            padding: '24px',
            transition: 'margin-left 0.2s',
            minHeight: '100vh',
            background: '#f5f5f5'
          }}
        >
          <Routes>
         

            <Route path="dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="camera" element={<PrivateRoute><CameraStatus /></PrivateRoute>} />
            <Route path="alert" element={<PrivateRoute><Alert /></PrivateRoute>} />
            <Route path="report" element={<PrivateRoute><Report /></PrivateRoute>} />
            <Route path="analytics" element={<PrivateRoute><CrowdAnalytics /></PrivateRoute>} />
            <Route path="attendance-logs" element={<PrivateRoute><AttendanceLogs /></PrivateRoute>} />
            <Route path="staff-summary" element={<PrivateRoute><StaffSummary /></PrivateRoute>} /> 
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default UserPage;